<template>
  <div class="box">
    <div style="width: 1820px; margin: auto; position: relative">
      <div class="title">
        <div style="margin: auto; display: flex">
          <p style="font-size: 36px; font-weight: 800; font-style: normal">
            TENGDA
          </p>
          <p style="font-size: 18px; margin-top: 12px; margin-left: 17px">
            {{ $t("footer.idea") }}
          </p>
        </div>
      </div>
      <div class="content">
        <div class="content_1">
          <p style="opacity: 1; margin-top: 47px">{{ $t("footer.contactUs") }}</p>
          <p>{{ $t("footer.address") }}</p>
          <!-- <p>{{ $t("footer.email") }}</p> -->
          <p>{{ $t("footer.tel") }}</p>
          <p>{{ $t("footer.fax") }}</p>
        </div>
        <div class="content_2">
          <div class="dimensional">
            <div style="width: 120px">
              <img src="../assets/首页/code1.png" alt="" />
              <p>{{ $t("footer.electronicSampleBooklet") }}</p>
            </div>
            <div style="width: 120px">
              <img src="../assets/首页/code2.png" alt="" />
              <p>{{ $t("footer.tengdaYougou") }}</p>
            </div>
          </div>
        </div>
        <div class="content_3">
          <div class="content_3_1">
            <div>
              <p @click="router.push('/regard')"> {{ $t("footer.aboutTengda") }}</p>
              <p @click="router.push('/product')">{{ $t("footer.productDisplay") }}</p>
              <p @click="router.push('/network')">{{ $t("footer.salesNetwork") }}</p>
            </div>

            <div>
              <p @click="router.push('/service')">{{ $t("footer.technicalService") }}</p>
              <p @click="add">{{ $t("footer.onlineMessage") }}</p>
              <p>{{ $t("footer.tengdaYougou") }}</p>
              <!-- <a
                href="http://sale.tdfastener.com:18080/"
                target="_blank"
                style="text-decoration: none"
              >

              </a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="lastLine">
        <p style="opacity: 0.5">@{{ $t("footer.company") }}</p>
        <p @click="router.push('/login')" class="backM">后台管理</p>
        <p style="opacity: 0.5">
          Copyright &nbsp;&nbsp;&nbsp; 2020-2028 TENGDA
          &nbsp;&nbsp;&nbsp;{{$t("footer.technicalSupport")}}&nbsp;&nbsp;&nbsp;{{ $t("footer.lu") }}
        </p>
      </div>
      <div class="lastLine" v-html="info"></div>
      <!-- <div @click="router.push('/login')" class="backEnd">后台管理</div> -->
    </div>
  </div>
</template>
<script setup>
import { useRoute, useRouter } from "vue-router";
// import { getCopyright } from "../api/index";
import { onMounted, ref } from "vue";
let ifshowd = ref(false);
let info = ref("");
const emit = defineEmits(["contact"]);
const add = () => {
  ifshowd.value = !ifshowd.value;
  emit("contact", ifshowd.value);
};

let copyright = async () => {
  const res = await getCopyright({ parms: JSON.stringify() });
  info.value = res.data.p_content;
};

// copyright();
// onMounted(() => {

// })

const router = useRouter();
const route = useRoute();
</script>
<style scoped lang="scss">
.lastLine {
  margin-top: 37px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  color: #fff;
  position: relative;
  font-weight: 400px;
  opacity: 0.5;

  // :deep(p) {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  // }
  :deep(p) {
    position: relative;
    bottom: 15px;
  }

  :deep(a) {
    color: #fff;
    text-decoration: none;
  }

  :deep(span:nth-child(1)) {
    margin-left: 886px;
  }
}
.lastLine .backM {
  cursor: pointer;
  position: absolute;
  margin-left: 338px;
  color: #0d0d0d !important;
}
// :deep(.lastLine .backM) {

//   color: #fff !important;

//    style="
//             cursor: pointer;
//             position: absolute;
//             margin-left: 338px;
//             color: #0d0d0d !important;
//           "
// }
.backM:active {
  color: #fff !important;
}
p {
  text-align: left;
  margin: 0;
  padding: 0;
}

.box {
  width: 100%;
  height: 572px;
  background-color: #0d0d0d;

  .title {
    height: 98px;
    display: flex;
    color: #fff;
    // background-color: aqua;
  }

  .content {
    width: 100%;
    height: 370px;
    display: flex;
    border-top: 1px solid rgb(56, 56, 56);
    border-bottom: 1px solid rgb(56, 56, 56);

    .content_1 {
      width: 616px;
      height: 100%;
      font-size: 22px;
      color: #fff;
      border-right: 1px solid rgb(56, 56, 56);

      p {
        opacity: 0.6000000238418579;
        margin-bottom: 30px;
      }
    }

    .content_2 {
      width: 586px;
      height: 100%;
      border-right: 1px solid rgb(56, 56, 56);

      .dimensional {
        width: 329px;
        height: 163px;
        margin: 125px auto;
        display: flex;
        justify-content: space-between;

        p {
          text-align: center;
          font-size: 16px;
          color: #fff;
          opacity: 0.6000000238418579;
          margin-top: 20px;
          font-weight: 600px;
        }
      }
    }

    .content_3 {
      width: 617px;
      height: 100%;

      .content_3_1 {
        margin-top: 143px;
        div {
          width: 617px;
          display: flex;
          flex-direction: row;
          justify-content: space-evenly;
          p {
            //width: 100%;
            // width: 166px;
    // border: 1px solid #fff;
            color: #fff;
            opacity: 0.6000000238418579;
            font-size: 22px;
            font-weight: 600px;
            height: 53px;
            //flex: 1;
            //justify-content: center;
            //text-align: center;
          }
        }
      }
    }
  }

  .backEnd {
    cursor: pointer;
    position: absolute;
    width: 72px;
    height: 25px;

    bottom: 33.5px;
    left: 302px;
    color: #ffffff;
    font-weight: 400px;
    font-size: 18px;
    font-style: normal;
    text-decoration: none;
    text-align: left;
    /*后台管理*/
    font-family: PingFangSC;
    color: #ffffff;
    font-weight: 400px;
    font-size: 18px;
    font-style: normal;
    text-decoration: none;
  }
}
</style>
